import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import PhotoOutlined from '@mui/icons-material/PhotoOutlined'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import MindsetImageTabStore from './MindsetImageTabStore'
import useInitialMount from 'reusable/hooks/useInitialMount'

interface MindsetImageTabProps {
   onAdd: (mindsetId: string, orgId: string) => void
}

export default observer(function MindsetImageTab({ onAdd }: MindsetImageTabProps) {
   const mindsetImageTabStore = useStore(sp => new MindsetImageTabStore(sp), { onAdd })

   useInitialMount(() => {
      mindsetImageTabStore.fetch()
   })

   if (mindsetImageTabStore.loader.isLoading) {
      return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
         <CircularProgress />
      </Box>
   }

   if (mindsetImageTabStore.mindsetsWithImages.length === 0) {
      return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
         <Typography color="text.secondary">No mindset images available</Typography>
      </Box>
   }

   return <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, maxHeight: 400, overflowY: 'auto' }}>
      {mindsetImageTabStore.mindsetsWithImages.map(mindset => (
         <Box
            key={mindset.id}
            data-id={mindset.id}
            onClick={mindsetImageTabStore.handleClick}
            sx={{
               cursor: 'pointer',
               borderRadius: 1,
               overflow: 'hidden',
               border: '1px solid',
               borderColor: 'divider',
               '&:hover': { borderColor: 'primary.main', boxShadow: 2 },
               transition: 'border-color 0.2s, box-shadow 0.2s',
            }}
         >
            <Box sx={{ display: 'flex', height: 120, justifyContent: 'center', alignItems: 'center', backgroundColor: 'action.hover' }}>
               {mindset.imageFileUrl
                  ? <img src={mindset.imageFileUrl} style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto' }} alt={mindset.name} />
                  : <PhotoOutlined sx={{ fontSize: 48, color: 'text.disabled' }} />
               }
            </Box>
            <Box sx={{ p: 1 }}>
               <Typography variant="caption" noWrap>{mindset.name}</Typography>
            </Box>
         </Box>
      ))}
   </Box>
})
